
  <zxing-scanner [torch]="torchEnabled" autofocusEnabled="true" [device]="deviceCurrent" previewFitMode="contain" (deviceChange)="onDeviceChange($event)" (scanSuccess)="onCodeResult($event)"
                 [formats]="formatsEnabled"  [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)"
                 (camerasFound)="onCamerasFound($event)" (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>

